import React, { createContext, useContext, useEffect, useState } from 'react';
import { portalAuthAPI } from '../lib/portal-api';

const EorPortalAuthContext = createContext(null);

export const useEorPortalAuth = () => {
  const ctx = useContext(EorPortalAuthContext);
  if (!ctx) throw new Error('useEorPortalAuth must be inside EorPortalAuthProvider');
  return ctx;
};

export const EorPortalAuthProvider = ({ children }) => {
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const boot = async () => {
      const token = localStorage.getItem('eor_portal_token');
      if (!token) { setLoading(false); return; }
      try {
        const res = await portalAuthAPI.me();
        setEmployee(res.data);
      } catch {
        localStorage.removeItem('eor_portal_token');
        localStorage.removeItem('eor_portal_employee');
      } finally {
        setLoading(false);
      }
    };
    boot();
  }, []);

  const setSession = (token, emp) => {
    localStorage.setItem('eor_portal_token', token);
    localStorage.setItem('eor_portal_employee', JSON.stringify(emp));
    setEmployee(emp);
  };

  const login = async (email, password) => {
    const res = await portalAuthAPI.login(email, password);
    setSession(res.data.access_token, res.data.employee);
    // fetch the full profile immediately
    try {
      const me = await portalAuthAPI.me();
      setEmployee(me.data);
    } catch {}
    return res.data.employee;
  };

  const acceptInvite = async (token, password) => {
    const res = await portalAuthAPI.acceptInvite(token, password);
    setSession(res.data.access_token, res.data.employee);
    try {
      const me = await portalAuthAPI.me();
      setEmployee(me.data);
    } catch {}
    return res.data.employee;
  };

  const logout = () => {
    localStorage.removeItem('eor_portal_token');
    localStorage.removeItem('eor_portal_employee');
    setEmployee(null);
  };

  const refresh = async () => {
    try {
      const res = await portalAuthAPI.me();
      setEmployee(res.data);
    } catch {}
  };

  return (
    <EorPortalAuthContext.Provider value={{ employee, loading, login, acceptInvite, logout, refresh, isAuthenticated: !!employee }}>
      {children}
    </EorPortalAuthContext.Provider>
  );
};
